import "react-image-crop/dist/ReactCrop.css";
import { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Container, Stack, Grid, Typography, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Close, Upload, AddPhotoAlternate } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import emptyImg from "assets/images/empty_01.png";
import { useTranslation } from "react-i18next";
import SubCard from "ui-component/cards/SubCard";

import { setLetterHead, clearLetterHead, selectLetterhead } from "../slice";

const ImageSelectZone = ({
    inputId,
    inputRef,
    previewUrl,
    onSelect,
    onClear,
    selectImageButtonName,
}) => {
    return (
        <Grid item xs={12} sm={12} md={12}>
            <SubCard
                title={
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <label htmlFor={inputId}>
                                <input
                                    ref={inputRef}
                                    accept="image/*"
                                    id={inputId}
                                    multiple
                                    type="file"
                                    style={{ display: "none" }}
                                    onChange={onSelect}
                                />
                                <LoadingButton
                                    disableElevation
                                    type="button"
                                    variant="outlined"
                                    color="secondary"
                                    component="span"
                                    startIcon={<Upload />}
                                >
                                    {selectImageButtonName}
                                </LoadingButton>
                            </label>
                        </Grid>

                        <Grid item>
                            <Button
                                disableElevation
                                type="button"
                                variant="text"
                                color="secondary"
                                component="span"
                                startIcon={<Close />}
                                onClick={onClear}
                            >
                                Clear Image
                            </Button>
                        </Grid>
                    </Grid>
                }
            >
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        alignItems="center"
                        justifyContent="center"
                        display="flex"
                        minHeight="150px"
                    >
                        <img
                            id="footerImage"
                            src={previewUrl === "" ? emptyImg : previewUrl}
                            alt=""
                            style={{
                                maxWidth: "700px",
                                maxHeight: "200px",
                                width: "auto",
                                height: "auto",
                            }}
                        />
                    </Grid>
                </Grid>
            </SubCard>
        </Grid>
    );
};

const HeaderAndFooterStep = () => {
    const { t } = useTranslation();
    const footerRef = useRef();
    const headerRef = useRef();
    const dispatch = useDispatch();

    const { header, footer } = useSelector(selectLetterhead);

    const handleUploadFile = (type, element) => {
        const file = element.target.files[0];

        if (file != null) {
            if (type === "header") {
                dispatch(
                    setLetterHead({
                        type,
                        value: {
                            ...header,
                            previewBlob: file,
                            previewUrl: URL.createObjectURL(file),
                        },
                    })
                );

                headerRef.current.value = "";
            } else {
                dispatch(
                    setLetterHead({
                        type,
                        value: {
                            ...footer,
                            previewBlob: file,
                            previewUrl: URL.createObjectURL(file),
                        },
                    })
                );

                footerRef.current.value = "";
            }
        }
    };

    const handleClearHeader = () => {
        dispatch(clearLetterHead("header"));
    };

    const handleClearFooter = () => {
        dispatch(clearLetterHead("footer"));
    };

    return (
        <Container maxWidth="lg" sx={{ mb: 1 }}>
            <Stack gap={1}>
                <Stack mb={1}>
                    <Stack direction="row" gap={0.5} alignItems="center" mb={1}>
                        <AddPhotoAlternate sx={{ color: grey[400], mb: 0.5 }} />
                        <Typography variant="h4" color="text.mediumDark">
                            {t("labels.add_digital_letterhead")}
                        </Typography>
                    </Stack>
                    <Typography variant="caption" color="text.mediumDark">
                        {t("messages.first_letterhead_message")}
                    </Typography>
                    <Typography variant="caption" color="text.mediumDark">
                        {t("messages.second_letterhead_message")}
                    </Typography>
                    <Typography variant="caption" color="text.mediumDark">
                        {t("messages.third_letterhead_message")}
                    </Typography>
                </Stack>
                <ImageSelectZone
                    inputRef={headerRef}
                    selectImageButtonName="Select Header File"
                    onSelect={(e) => handleUploadFile("header", e)}
                    previewUrl={header.previewUrl}
                    onClear={handleClearHeader}
                />
                <ImageSelectZone
                    inputRef={footerRef}
                    selectImageButtonName="Select Footer File"
                    onSelect={(e) => handleUploadFile("footer", e)}
                    previewUrl={footer.previewUrl}
                    onClear={handleClearFooter}
                />
            </Stack>
        </Container>
    );
};

export default HeaderAndFooterStep;
